export const spaceTop = 'mt-4';
export const startButton = 'mt-4 mb-4 w-full';
export const saveAndExitButton = 'mb-4 w-full';
